import { z } from "zod";
import { NOTES_TABLES } from "../../../types/notes";

export const getNoteSchema = z.object({
	noteId: z.string().uuid(),
});

/**
 * Where the note is being read: the join table it hangs in and the parent it hangs off.
 *
 * A note carries no reference to its parent, so a bare id says nothing about who may see the
 * note. The caller names the context it is looking at, the handler checks that the note really
 * hangs there, and the parent's read right decides. Both halves travel together or neither does —
 * a caller reading a note of their own needs no context at all.
 */
export const getNoteQuerySchema = z
	.object({
		notesTable: z.enum(NOTES_TABLES).optional(),
		identifier: z.string().uuid().optional(),
	})
	.refine((query) => !!query.notesTable === !!query.identifier, {
		message: "notesTable and identifier name one parent and are given together",
	});

export type GetNoteQuery = z.infer<typeof getNoteQuerySchema>;
